(() => {
  if (window.StoritimeSortMenuInitialized) return;
  window.StoritimeSortMenuInitialized = true;

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-storitime-sort-value]');
    if (!option) return;

    const form = option.closest('facet-filters-form');
    const select = form?.querySelector('.facet-filters__sort');
    if (!select) return;

    event.preventDefault();
    select.value = option.dataset.storitimeSortValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    const menu = option.closest('.storitime-sort-menu');
    if (menu) menu.removeAttribute('open');
  });
})();
